module.exports = __webpack_public_path__ + "img/icon_map_4_off_101.8c63bfa6.png";